import { useState } from 'react';
import { isValidGeocodeInput } from '@/utils/utils';

interface Coordinates {
  lat: number;
  lng: number;
  state?: string;
}

const useCoordinates = () => {
  const [coordinates, setCoordinates] = useState<Coordinates | null>(null);
  const [errorState, setErrorState] = useState<string | null>(null);
  const getStateShortName = addressComponents => {
    if (!Array.isArray(addressComponents)) {
      return addressComponents.short_name || '';
    }
    return addressComponents[0].short_name || '';
  };

  const getCoordinates = async (location: string) => {
    if (!isValidGeocodeInput(location)) {
      setErrorState('Error fetching coordinates.');
      return null;
    }
    try {
      const response = await fetch('/api/geocode/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ location }),
      });

      if (response.ok) {
        const { results } = await response.json();
        const { lat, lng } = results.results[0].geometry.location;
        const state =
          results.results[0].types[0] === 'administrative_area_level_1'
            ? getStateShortName(results.results[0].address_components)
            : '';
        const newCoordinates = { lat, lng, state };
        setCoordinates(newCoordinates);
        setErrorState(null);
        return newCoordinates;
      }
      setErrorState('Location not found.');
      return null;
    } catch (error) {
      setErrorState('Error fetching coordinates.');
      return null;
    }
  };

  return { coordinates, errorState, getCoordinates };
};

export default useCoordinates;
